import { getLangName } from '@/constants/ElementPlusLangConfig'
import classNames from 'classnames'
import { useI18n } from 'i18n-utils'
import { useLanguageStore, useStaticTableDataStore } from 'store'
import { CheckIcon, InputView } from 'ui-components'
import { DefineComponentProps } from 'utils'
import './MobileChangeLanguage.scss'

type MobileChangeLanguageProps = {
  onLanguageChange?: (item: ApiResponse.StaticLangI18n) => void
}

export const MobileChangeLanguage = defineComponent<MobileChangeLanguageProps>({
  props: DefineComponentProps<MobileChangeLanguageProps>(['onLanguageChange']),
  setup(props) {
    const { t } = useI18n()
    const languageStore = useLanguageStore()
    const staticTableStore = useStaticTableDataStore()
    const searchValue = ref('')
    const langList = computed(() => {
      return staticTableStore.langList.filter((item) => {
        if (!searchValue.value) return true
        const langName = getLangName(item.langName)
        if (!langName) return false
        return langName.toLowerCase().includes(searchValue.value.toLowerCase())
      })
    })

    const onLanguageChange = (item: ApiResponse.StaticLangI18n) => {
      languageStore.setCurrentLanguage(item.langName)
      props.onLanguageChange?.(item)
    }

    return () => (
      <div class="mobile-change-language-layout">
        <InputView v-model={searchValue.value} placeholder={t('搜索语言')} />
        <div class="lang-list">
          {langList.value.map((item) => {
            const langName = getLangName(item.langName)
            if (!langName) return null
            return (
              <div
                class={classNames('lang-item', {
                  active: item.langName === languageStore.currentLanguage,
                })}
                key={item.langName}
                onClick={() => onLanguageChange(item)}
              >
                <span class="lang-item-name">{langName}</span>
                {item.langName === languageStore.currentLanguage && <CheckIcon />}
              </div>
            )
          })}
        </div>
      </div>
    )
  },
})
